<div class="card flex flex-col h-full justify-between">
    <div class="info-widget-header">
        <h3 class="info-widget-title">{{ title }}</h3>
        <fa-icon [icon]="icon" class="info-widget-icon"></fa-icon>
    </div>
    <div class="content">
        <ng-content></ng-content>
    </div>
</div>
